<template>
  <div class="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
    <div class="container mx-auto px-4 py-8">
      <!-- Header -->
      <div class="text-center mb-12">
        <h1 class="text-4xl font-bold text-gray-900 mb-4">
          🎮 ESP32S3 Remote Controller
        </h1>
        <p class="text-xl text-gray-600 max-w-2xl mx-auto">
          Điều khiển Android từ xa qua ESP32S3 với giao diện web hiện đại
        </p>
      </div>

      <!-- Features Grid -->
      <div class="grid md:grid-cols-3 gap-8 mb-12">
        <div class="bg-white rounded-xl p-6 shadow-lg">
          <div class="text-3xl mb-4">⌨️</div>
          <h3 class="text-xl font-semibold mb-2">Bàn phím ảo</h3>
          <p class="text-gray-600">
            Gửi lệnh bàn phím trực tiếp từ web interface với mapping HID chuẩn
          </p>
        </div>

        <div class="bg-white rounded-xl p-6 shadow-lg">
          <div class="text-3xl mb-4">🖱️</div>
          <h3 class="text-xl font-semibold mb-2">Chuột ảo</h3>
          <p class="text-gray-600">
            Điều khiển chuột với click, di chuyển và scroll mượt mà
          </p>
        </div>

        <div class="bg-white rounded-xl p-6 shadow-lg">
          <div class="text-3xl mb-4">🌐</div>
          <h3 class="text-xl font-semibold mb-2">Điều khiển từ xa</h3>
          <p class="text-gray-600">
            Kết nối qua Cloudflare Workers, hoạt động từ mọi nơi trên internet
          </p>
        </div>
      </div>

      <!-- Quick Start -->
      <div class="bg-white rounded-xl p-8 shadow-lg max-w-4xl mx-auto">
        <h2 class="text-2xl font-bold mb-6 text-center">🚀 Bắt đầu nhanh</h2>
        
        <div class="grid md:grid-cols-2 gap-8">
          <div>
            <h3 class="text-lg font-semibold mb-4">Cấu hình ESP32S3</h3>
            <ol class="space-y-3 text-gray-600">
              <li class="flex items-start">
                <span class="bg-blue-100 text-blue-800 rounded-full w-6 h-6 flex items-center justify-center text-sm font-medium mr-3 mt-0.5">1</span>
                Flash code lên ESP32S3 với IP address
              </li>
              <li class="flex items-start">
                <span class="bg-blue-100 text-blue-800 rounded-full w-6 h-6 flex items-center justify-center text-sm font-medium mr-3 mt-0.5">2</span>
                Kết nối ESP32S3 với Android qua USB
              </li>
              <li class="flex items-start">
                <span class="bg-blue-100 text-blue-800 rounded-full w-6 h-6 flex items-center justify-center text-sm font-medium mr-3 mt-0.5">3</span>
                Đảm bảo ESP32S3 có kết nối WiFi
              </li>
            </ol>
          </div>

          <div>
            <h3 class="text-lg font-semibold mb-4">Sử dụng Web Controller</h3>
            <ol class="space-y-3 text-gray-600">
              <li class="flex items-start">
                <span class="bg-green-100 text-green-800 rounded-full w-6 h-6 flex items-center justify-center text-sm font-medium mr-3 mt-0.5">1</span>
                Nhập API Key và Device ID
              </li>
              <li class="flex items-start">
                <span class="bg-green-100 text-green-800 rounded-full w-6 h-6 flex items-center justify-center text-sm font-medium mr-3 mt-0.5">2</span>
                Click "Kết nối" để thiết lập
              </li>
              <li class="flex items-start">
                <span class="bg-green-100 text-green-800 rounded-full w-6 h-6 flex items-center justify-center text-sm font-medium mr-3 mt-0.5">3</span>
                Bắt đầu điều khiển Android!
              </li>
            </ol>
          </div>
        </div>

        <div class="text-center mt-8">
          <RouterLink 
            to="/controller"
            class="inline-flex items-center px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
          >
            🎮 Bắt đầu điều khiển
            <svg class="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </RouterLink>
        </div>
      </div>

      <!-- Status -->
      <div class="mt-8 text-center">
        <div class="inline-flex items-center px-4 py-2 bg-gray-100 rounded-full">
          <div class="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
          <span class="text-sm text-gray-600">Hệ thống hoạt động bình thường</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// Home view component
</script> 